<template>
  <div class="login-wrap">
    <div class="login-panel">
      <div class="header-logo">
        <div class="logo-icon">
           <i></i>
        </div>
        <h1 class="logo-name">MRChat</h1>
      </div>
      <div class="login-title">欢迎登录</div>
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" placeholder="请输入用户名">
            <i slot="prefix" class="el-icon-user"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" type="password" placeholder="请输入密码">
            <i slot="prefix" class="el-icon-lock"></i>
          </el-input>
        </el-form-item>
        <el-form-item prop="code" v-if="loginForm.code">
          <el-input v-model="loginForm.code" placeholder="请输入验证码">
            <i slot="prefix" class="el-icon-key"></i>
          </el-input>
        </el-form-item>
        <div class="login-action">
          <el-button type="primary" @click="handleLogin">登录</el-button>
          <el-button @click="handleReset">重置</el-button>
        </div>
      </el-form>
    </div>
    <div class="login-footer">
      Copyright © 2024 MRChat All Rights Reserved
    </div>
  </div>
</template>

<script>
import api from '@/utils/api';
import {setUserInfo,setToken} from '@/utils/store';

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        code: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
         try {
          api.login(this.loginForm).then(res => {
              setToken(res.access_token);
              setUserInfo(res);
              this.$router.push('/');
          });
        } catch (error) {
          this.$message.error(error.message);
        }}
      });
    },
    handleReset() {
      this.$refs.loginForm.resetFields();
    }
  }
}
</script>

<style>
/* 移除所有样式，因为已经移到了 app.css 中 */
</style>


// WEBPACK FOOTER //
// src/components/Login.vue